// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPayrollGroupReducedDto } from './IPayrollGroupReducedDto';
import {
    IPayrollGroupReducedDtoFromJSON,
    IPayrollGroupReducedDtoFromJSONTyped,
    IPayrollGroupReducedDtoToJSON,
    IPayrollGroupReducedDtoToJSONTyped,
} from './IPayrollGroupReducedDto';
import type { ICalculateScheduleRequestDto } from './ICalculateScheduleRequestDto';
import {
    ICalculateScheduleRequestDtoFromJSON,
    ICalculateScheduleRequestDtoFromJSONTyped,
    ICalculateScheduleRequestDtoToJSON,
    ICalculateScheduleRequestDtoToJSONTyped,
} from './ICalculateScheduleRequestDto';
import type { IPlanLiteDto } from './IPlanLiteDto';
import {
    IPlanLiteDtoFromJSON,
    IPlanLiteDtoFromJSONTyped,
    IPlanLiteDtoToJSON,
    IPlanLiteDtoToJSONTyped,
} from './IPlanLiteDto';

/**
 * 
 * @export
 * @interface IPayrollCalendarExtendedAggregatorResponseDto
 */
export interface IPayrollCalendarExtendedAggregatorResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IPayrollCalendarExtendedAggregatorResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarExtendedAggregatorResponseDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarExtendedAggregatorResponseDto
     */
    frequency_type?: IPayrollCalendarExtendedAggregatorResponseDtoFrequencyTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollCalendarExtendedAggregatorResponseDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollCalendarExtendedAggregatorResponseDto
     */
    start_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollCalendarExtendedAggregatorResponseDto
     */
    end_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarExtendedAggregatorResponseDto
     */
    status?: IPayrollCalendarExtendedAggregatorResponseDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IPayrollCalendarExtendedAggregatorResponseDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarExtendedAggregatorResponseDto
     */
    organization_path?: string;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollCalendarExtendedAggregatorResponseDto
     */
    next_autoprolong_at?: Date;
    /**
     * 
     * @type {ICalculateScheduleRequestDto}
     * @memberof IPayrollCalendarExtendedAggregatorResponseDto
     */
    config?: ICalculateScheduleRequestDto;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarExtendedAggregatorResponseDto
     */
    group_type?: IPayrollCalendarExtendedAggregatorResponseDtoGroupTypeEnum;
    /**
     * 
     * @type {Array<Date>}
     * @memberof IPayrollCalendarExtendedAggregatorResponseDto
     */
    schedule?: Array<Date>;
    /**
     * 
     * @type {Set<IPlanLiteDto>}
     * @memberof IPayrollCalendarExtendedAggregatorResponseDto
     */
    calendar_plans?: Set<IPlanLiteDto>;
    /**
     * 
     * @type {Set<IPlanLiteDto>}
     * @memberof IPayrollCalendarExtendedAggregatorResponseDto
     */
    non_calendar_plans?: Set<IPlanLiteDto>;
    /**
     * 
     * @type {Set<IPayrollGroupReducedDto>}
     * @memberof IPayrollCalendarExtendedAggregatorResponseDto
     */
    calendar_payroll_groups?: Set<IPayrollGroupReducedDto>;
    /**
     * 
     * @type {Set<IPayrollGroupReducedDto>}
     * @memberof IPayrollCalendarExtendedAggregatorResponseDto
     */
    non_calendar_payroll_groups?: Set<IPayrollGroupReducedDto>;
}

/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarExtendedAggregatorResponseDtoFrequencyTypeEnum {
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    MONTHLY = 'MONTHLY',
    SEMI_MONTHLY = 'SEMI_MONTHLY',
    ANNUALLY = 'ANNUALLY'
}
/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarExtendedAggregatorResponseDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    DEACTIVATED = 'DEACTIVATED'
}
/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarExtendedAggregatorResponseDtoGroupTypeEnum {
    ALL = 'ALL',
    GROUP = 'GROUP',
    PLAN = 'PLAN'
}


/**
 * Check if a given object implements the IPayrollCalendarExtendedAggregatorResponseDto interface.
 */
export function instanceOfIPayrollCalendarExtendedAggregatorResponseDto(value: object): value is IPayrollCalendarExtendedAggregatorResponseDto {
    return true;
}

export function IPayrollCalendarExtendedAggregatorResponseDtoFromJSON(json: any): IPayrollCalendarExtendedAggregatorResponseDto {
    return IPayrollCalendarExtendedAggregatorResponseDtoFromJSONTyped(json, false);
}

export function IPayrollCalendarExtendedAggregatorResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayrollCalendarExtendedAggregatorResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'frequency_type': json['frequency_type'] == null ? undefined : json['frequency_type'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'start_date': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'end_date': json['end_date'] == null ? undefined : (new Date(json['end_date'])),
        'status': json['status'] == null ? undefined : json['status'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'next_autoprolong_at': json['next_autoprolong_at'] == null ? undefined : (new Date(json['next_autoprolong_at'])),
        'config': json['config'] == null ? undefined : ICalculateScheduleRequestDtoFromJSON(json['config']),
        'group_type': json['group_type'] == null ? undefined : json['group_type'],
        'schedule': json['schedule'] == null ? undefined : json['schedule'],
        'calendar_plans': json['calendar_plans'] == null ? undefined : (new Set((json['calendar_plans'] as Array<any>).map(IPlanLiteDtoFromJSON))),
        'non_calendar_plans': json['non_calendar_plans'] == null ? undefined : (new Set((json['non_calendar_plans'] as Array<any>).map(IPlanLiteDtoFromJSON))),
        'calendar_payroll_groups': json['calendar_payroll_groups'] == null ? undefined : (new Set((json['calendar_payroll_groups'] as Array<any>).map(IPayrollGroupReducedDtoFromJSON))),
        'non_calendar_payroll_groups': json['non_calendar_payroll_groups'] == null ? undefined : (new Set((json['non_calendar_payroll_groups'] as Array<any>).map(IPayrollGroupReducedDtoFromJSON))),
    };
}

export function IPayrollCalendarExtendedAggregatorResponseDtoToJSON(json: any): IPayrollCalendarExtendedAggregatorResponseDto {
    return IPayrollCalendarExtendedAggregatorResponseDtoToJSONTyped(json, false);
}

export function IPayrollCalendarExtendedAggregatorResponseDtoToJSONTyped(value?: IPayrollCalendarExtendedAggregatorResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'frequency_type': value['frequency_type'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'start_date': value['start_date'] == null ? undefined : ((value['start_date']).toISOString()),
        'end_date': value['end_date'] == null ? undefined : ((value['end_date']).toISOString()),
        'status': value['status'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'next_autoprolong_at': value['next_autoprolong_at'] == null ? undefined : ((value['next_autoprolong_at']).toISOString()),
        'config': ICalculateScheduleRequestDtoToJSON(value['config']),
        'group_type': value['group_type'],
        'schedule': value['schedule'],
        'calendar_plans': value['calendar_plans'] == null ? undefined : (Array.from(value['calendar_plans'] as Set<any>).map(IPlanLiteDtoToJSON)),
        'non_calendar_plans': value['non_calendar_plans'] == null ? undefined : (Array.from(value['non_calendar_plans'] as Set<any>).map(IPlanLiteDtoToJSON)),
        'calendar_payroll_groups': value['calendar_payroll_groups'] == null ? undefined : (Array.from(value['calendar_payroll_groups'] as Set<any>).map(IPayrollGroupReducedDtoToJSON)),
        'non_calendar_payroll_groups': value['non_calendar_payroll_groups'] == null ? undefined : (Array.from(value['non_calendar_payroll_groups'] as Set<any>).map(IPayrollGroupReducedDtoToJSON)),
    };
}

